import React, { useState } from 'react';
import { SwitchableElement } from '../../schema/switchable.schema';
import DropdownComponent from './Dropdown';
import Tabs from './Tabs';
import { FormDataValue } from '../../hooks/useFormData';
import CollapsibleMap from './Collapsible';

interface SwitchableComponentProps {
	element: SwitchableElement;
	onChange: (key: string, value: FormDataValue) => void;
	onValidationChange: (key: string, value: boolean) => void;
}

const SwitchableComponent: React.FC<SwitchableComponentProps> = ({ element, onChange, onValidationChange }) => {
	const { tags, selected, options, key } = element;
	const [currentOption, setCurrentOption] = useState(selected);
	const [openIndex, setOpenIndex] = useState<number | null>(options.findIndex((option) => option.value === selected));

	const handleChange = (value: string) => {
		setCurrentOption(value);
		onChange(key, value);
		onValidationChange(value, true);
	};

	switch (true) {
		case tags.includes('DROPDOWN'):
			return (
				<DropdownComponent
					options={options}
					currentOption={currentOption}
					handleChange={handleChange}
					onValidationChange={onValidationChange}
					onChange={onChange}
				/>
			);
		case tags.includes('COLLAPSIBLE'):
			return (
				<CollapsibleMap
					key={openIndex}
					currentOption={currentOption}
					openIndex={openIndex}
					setOpenIndex={setOpenIndex}
					onValidationChange={onValidationChange}
					onChange={onChange}
					handleChange={handleChange}
					options={options}
				/>
			);
		case tags.includes('TABS'):
			return (
				<Tabs
					currentOption={currentOption}
					handleChange={handleChange}
					options={options}
					onValidationChange={onValidationChange}
					onChange={onChange}
				/>
			);
		default:
			return (
				<DropdownComponent
					options={options}
					currentOption={currentOption}
					handleChange={handleChange}
					onValidationChange={onValidationChange}
					onChange={onChange}
				/>
			);
	}
};

export default SwitchableComponent;
